import { trackProductAction } from '@/libs/product-analytics';
import { useMutation } from '@tanstack/react-query';
import type {
  AffiliateCsvImportCreatedResponse,
  AffiliateCsvImportRequest,
  ApiResponse,
} from '@fluenceur/types';
import api from '@/libs/axiosInstance';

export type StartImportParams = AffiliateCsvImportRequest & {
  programId: string;
};

/** Keeps the wire contract discriminated: link imports never leak email fields. */
export const buildAffiliateCsvImportRequest = (
  params: StartImportParams
): AffiliateCsvImportRequest => {
  const { programId: _programId, ...request } = params;
  return request;
};

export const useAffiliateCsvImport = () =>
  useMutation({
    mutationFn: async (params: StartImportParams): Promise<AffiliateCsvImportCreatedResponse> => {
      return trackProductAction('imports', 'start', async () => {
        // batchId is the existing bulk_invitation_batches.id (we reuse that table per locked PLAN).
        const response = await api.post<ApiResponse<AffiliateCsvImportCreatedResponse>>(
          `/dashboard/programs/${params.programId}/affiliate-imports`,
          buildAffiliateCsvImportRequest(params)
        );
        if (!response.data.data) {
          throw new Error(response.data.message ?? 'Failed to queue import');
        }
        return response.data.data;
      });
    },
  });
